import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MingJingApp } from "../app/MingJingApp.tsx";
import "../app/globals.css";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

createRoot(root).render(
  <StrictMode>
    <MingJingApp />
  </StrictMode>,
);
